var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import BaseAudioEffector from './base-audio-effector';
/**
 * 声音空间效果，其实就是3D环绕
 */
var SpatialStereoEffector = /** @class */ (function (_super) {
    __extends(SpatialStereoEffector, _super);
    function SpatialStereoEffector(audioCtx, audioSource, logger) {
        var _this = _super.call(this, audioCtx, audioSource, logger) || this;
        // 更新panner位置时间间隔
        _this.intervalTime = 300;
        _this.startTimeStamp = 0;
        // 3D环绕半径
        _this.radius = 3;
        // 旋转速度，单位度数
        _this.degreeSpeed = 4;
        // 旋转开始位置
        _this.degreeStart = 0;
        // 旋转最大度数
        _this.degreeMax = 360;
        // 相关文档较少，设置空间定位音频的算法，HRTF含义为：Head-related transfer function
        _this.panningModel = 'HRTF';
        // 使用linear算法来降低音频源远离听众时的音量
        _this.distanceModel = 'linear';
        _this.effectorName = 'Spatial Stereo';
        _this.pannerNode = _this.audioCtx.createPanner();
        _this.pannerNode.panningModel = _this.panningModel;
        _this.pannerNode.distanceModel = _this.distanceModel;
        // 音源参考距离
        _this.pannerNode.refDistance = 1;
        // 指定音源发出的位置
        _this.pannerNode.coneInnerAngle = 360;
        _this.pannerNode.coneOuterAngle = 0;
        // 音源增益为0
        _this.pannerNode.coneOuterGain = 1;
        _this.isConnected = false;
        return _this;
    }
    SpatialStereoEffector.prototype.connectBy = function (node) {
        if (!node || !this.pannerNode) {
            return null;
        }
        node.connect(this.pannerNode);
        this.isConnected = true;
        return this.pannerNode;
    };
    SpatialStereoEffector.prototype.disconnect = function () {
        var _a, _b;
        (_a = this.pannerNode) === null || _a === void 0 ? void 0 : _a.disconnect();
        this.isConnected = false;
        (_b = this.logger) === null || _b === void 0 ? void 0 : _b.log("".concat(this.effectorName, " disconnect()"));
    };
    SpatialStereoEffector.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        this.pannerNode = null;
    };
    /**
     * 更新Loop时间间隔，保持默认300ms更新一次
     */
    SpatialStereoEffector.prototype.updateLoop = function () {
        // 如果没有连接音效，不需要更新位置
        if (!this.isConnected) {
            return;
        }
        var curTimeStamp = +new Date();
        if (curTimeStamp - this.startTimeStamp > this.intervalTime) {
            this.updatePanningPosition();
            this.startTimeStamp = curTimeStamp;
        }
    };
    /**
     * 更新音效空间位置
     */
    SpatialStereoEffector.prototype.updatePanningPosition = function () {
        var rl = this.degreeStart * Math.PI / 180;
        this.pannerNode.positionX.value = this.radius * Math.cos(rl);
        this.pannerNode.positionZ.value = this.radius * Math.sin(rl);
        this.degreeStart += this.degreeSpeed;
        // 超过最大度数就恢复为初始位置
        if (this.degreeStart >= this.degreeMax) {
            this.degreeStart = this.degreeStart - this.degreeMax;
        }
    };
    return SpatialStereoEffector;
}(BaseAudioEffector));
export default SpatialStereoEffector;
